import { AlertCircle, AlertTriangle } from 'lucide-react';
import { siteConfig } from '@/config/site';
import { useLanguage } from '@/context/LanguageContext';

export function BoundariesSection() {
  const { language } = useLanguage();
  const content = siteConfig.content[language].boundaries;

  const additionalNotes = {
    en: {
      finesNote: 'Members are subject to fines for disciplinary action.',
      universalNote: 'House rules include common sense and universal standards of respect and decency, even if not exhaustively listed.'
    },
    es: {
      finesNote: 'Los miembros están sujetos a multas por acciones disciplinarias.',
      universalNote: 'Las reglas de la casa incluyen sentido común y estándares universales de respeto y decencia, aunque no estén listados exhaustivamente.'
    }
  };

  const an = additionalNotes[language];

  return (
    <section id="boundaries" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0A12]" data-testid="boundaries-section">
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-[#FF4DA6] text-sm font-semibold uppercase tracking-widest mb-2">
            {content.subtitle}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#F4F2FF]">
            {content.title}
          </h2>
        </div>

        {/* Rules Card */}
        <div className="neon-card border-[#FF4DA6]/30">
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10">
            <div className="w-10 h-10 rounded-full bg-[#FF4DA6]/20 flex items-center justify-center">
              <AlertCircle className="w-5 h-5 text-[#FF4DA6]" />
            </div>
            <span className="text-[#FF4DA6] font-semibold uppercase tracking-wider text-sm">
              {language === 'en' ? 'House Rules' : 'Reglas de la Casa'}
            </span>
          </div>

          <ul className="space-y-4 mb-6">
            {content.rules.map((rule, idx) => (
              <li key={idx} className="flex items-start gap-3" data-testid={`rule-${idx}`}>
                <span className="w-6 h-6 rounded-full bg-gradient-to-br from-[#FF4DA6]/20 to-[#8B5CFF]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-[#FF4DA6]">{idx + 1}</span>
                </span>
                <span className="text-[#F4F2FF] text-base">{rule}</span>
              </li>
            ))}
          </ul>

          {/* Additional notes per spec */}
          <div className="pt-6 border-t border-white/10 space-y-4">
            <div className="flex items-start gap-3 p-4 rounded-xl bg-[#FF4DA6]/5 border border-[#FF4DA6]/20">
              <AlertTriangle className="w-5 h-5 text-[#FF4DA6] flex-shrink-0 mt-0.5" />
              <p className="text-[#FF4DA6] text-sm font-medium">{an.finesNote}</p>
            </div>
            <p className="text-[#A7A3BA] text-xs italic px-4">
              {an.universalNote}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BoundariesSection;
